<template>
  <div class="pageysc">
    <XR-head :titleText="'我的' + chainCname" :rightShow="true"></XR-head>    
    <div class="total balance" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="title">{{chainCname}}总额</p>
      <p class="money">{{yscInfo.Coin.toFixed(4)}}</p>
    </div>
    <div class="total account-address" v-if="!loaded">
      <p class="title"></p>
      <p class="address" ref="yscText">{{UserInfo.Purse}}</p>
      <p class="copybtn" @click="copyText()">复制地址</p>
    </div>

    <div class="sub-nav" v-if="!loaded">
      <mu-list>
        <router-link to="/usercenter/yscRecharge">
          <mu-list-item :title="chainCname + '充值'">
            <mu-icon slot="left" value=":fa fa-money7"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <!-- <router-link to="/usercenter/yscWithdraw">
          <mu-list-item :title="chainCname + '提现'">
            <mu-icon slot="left" value=":fa fa-withdraw"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/> -->
        <router-link to="/usercenter/yscStream">
          <mu-list-item :title="chainCname + '查询'">
            <mu-icon slot="left" value=":fa fa-money"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
      </mu-list>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import {ErrorCode} from '../../../../util/errorcode'
import siteconfig from '../../../../util/siteconfigCache'
export default {
  data() {
    return {
      loaded : true,
      UserInfo:{
        Purse:''
      },
      yscInfo:{
        Coin:0
      },
      siteConfig:{ MobileBgImage : '' }
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    
    this.getSiteInfo()
    this.getUserInfo()
    this.getyscInfo()
  },
  methods: {
    getSiteInfo: function () {
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
            siteconfig.addSiteconfig(res.Data)
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },
    getUserInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(res.IsSuccess){        
          ths.UserInfo = res.Data;
        }
      });
    },
    getyscInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/yscServer/GetyscAccountInfo"
      ).then(function(res) {
        if(!res.IsSuccess){          
          if(res.TypeId == 1){
            ths.$router.push("/usercenter/yscActive")
          }
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.yscInfo = res.Data;
          ths.loaded=false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    copyText: function(){
    var oInput = document.createElement('input')
        oInput.value = this.UserInfo.Purse
        document.body.appendChild(oInput)
        oInput.select()
        document.execCommand("Copy")
        document.body.removeChild(oInput)
        this.$refs.XRtoast.success("复制成功", true)
    }
}
}
</script>
<style>
.pageysc .total{
  background: white;
  padding: 20px 20px;
}
.pageysc .total.balance{
  overflow: hidden;
 background: url('/static/us-top-bg.png');
  background-size: 100% 100%;
}
.pageysc .title{
  line-height: 24px;
  font-size: 14px;
}
.pageysc .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
}
.pageysc .total.balance .title{
  color:white;
}
.pageysc .total.balance .money{
  color:white;
}


.pageysc .sub-nav{
  background: white;
  margin-top: 10px;
}

.pageysc .account-address .address {
  font-size:12px;
  color:black;
  background:#efefef;
  margin: 10px 0 20px;
  height:50px;
  line-height:50px;
  text-align: center;
}
.pageysc .account-address .copybtn{
  text-align: center;
  font-size: 12px;
  color:Red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/ysc/local/ysc.vue